export const BASE_URL = "https://boxmealadminapinew.azurewebsites.net/api";
const baseProductUrl = "https://boxmealadminapinew.azurewebsites.net/api/product";
// const baseProductUrl = "https://localhost:7255/api/product";
// export const BASE_URL = "https://localhost:7255/api";
const getAllCategoriesEndpoint = `${baseProductUrl}/getallcategories`;
const getAllCategoriesEndpointMobile = `${baseProductUrl}/getallcategoriesMobile`;
export const BASE_URL_IMAGE =
  "https://boxmealadmin.blob.core.windows.net/productimage/";

const baseFridgeUrl = "https://boxmealadminapinew.azurewebsites.net/api/fridge";

export const getAllProducts = async (fridgeId, options) => {
  const params = new URLSearchParams();
  if (options && options.teamPlayerId) {
    params.set("teamPlayerId", options.teamPlayerId);
  }
  const qs = params.toString();
  const url = `${BASE_URL}/Fridge/${fridgeId}/products${qs ? `?${qs}` : ""}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Error response data:", errorData);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Fetched products:", data);

    return data;
  } catch (error) {
    console.error("Error fetching products:", error.message);
    throw error;
  }
};

export const getAllCategories = async (token) => {
  try {
    const response = await fetch(getAllCategoriesEndpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const categories = await response.json();
    console.log("Fetched categories:", categories);
    return categories;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const getAllCategoriesMobile = async (token, selectedFridgeId) => {
  try {
    const url = `${getAllCategoriesEndpointMobile}?selectedFridgeId=${selectedFridgeId}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const getAllTeamPlayers = async (token) => {
  try {
    const url = `${baseProductUrl}/GetAllTeamPlayers`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching team players:", error);
    throw error;
  }
};

// New: fetch team players by fridge id (authorized, reads customer from JWT, filters by fridge)
export const getAllTeamPlayersByFridgeId = async (token, selectedFridgeId) => {
  try {
    const url = `${baseProductUrl}/GetAllTeamPlayersByFridgeId?fridgeId=${encodeURIComponent(
      selectedFridgeId
    )}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching team players by fridge:", error);
    throw error;
  }
};

export const getFridgesByCustomerId = async (customerId) => {
  try {
    const response = await fetch(`${baseFridgeUrl}/customer/${customerId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching fridges:", error);
    throw error; // Propagate the error to the calling function
  }
};
